import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import CCTextInput from '@/Atoms/CCTextInput';
import Spacer from '@/Atoms/Spacer';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {View, Image, StyleSheet, TouchableOpacity} from 'react-native';
import search from '../../Assets/Images/png/search.png';
import SlideModal from '@/Atoms/SlideModal';
import CCTabs from '@/Atoms/CCTabs';
import useGetUserAccessApi from '@/Hooks/UserAccessApi/useUserAccessApi';
import StudentListComponent from './StudentList';
import {SceneMap, TabView, TabBar} from 'react-native-tab-view';
import PendingRequest from './PendingRequest';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import useRequestUserRelations from '@/Hooks/UserAccessApi/useRequestUserRelations';
import {useUserAccessStore} from '@/Hooks/UserAccessApi/store/useUserAccessStore';
import {useNavigation, useRoute} from '@react-navigation/native';

const RequestAccess = ({setModifyMainMenu, userData}) => {
  const navigation = useNavigation();
  const route = useRoute();
  const params = route?.params || {};
  const initialTabKey = params?.tabType?.toLowerCase() || 'coach';
  const {isMobileOrTab} = useMediaQuery();
  const [tabType, setTabType] = useState('students_list');
  const [openRequestAccess, setOpenRequestAccess] = useState(false);
  const [userRelationData, setUserRelationData] = useState({});
  const [mobileNumber, setMobileNumber] = useState('');
  const [selectedCoachType, setSelectedCoachType] = useState<string>();
  const [formError, setFormError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [relationType, setRelationType] = useState(0);
  const [userAccessCache, setUserAccessCache] = useState({
    0: null, // coach/parent/mentor
    1: null, // profile
  });

  const handleUserAccessSuccess = data => {
    const relationTypeKey = data?.relation_type || 0;
    setUserAccessCache(prev => ({
      ...prev,
      [relationTypeKey]: data?.user_access,
    }));
    setUserRelationData(data?.user_access);
  };
  const handleUserAccessError = () => {};
  const {
    mutate: userAccess,
    data: userAccessData,
    isLoading,
  } = useGetUserAccessApi(handleUserAccessSuccess, handleUserAccessError);

  const userAccessZustand = useUserAccessStore(state => state.userAccess);

  useEffect(() => {
    if (userAccessZustand) {
      setUserRelationData(userAccessZustand);
    }
  }, [userAccessZustand]);

  useEffect(() => {
    const initialType = initialTabKey === 'profile' ? 1 : 0;
    setRelationType(initialType);

    if (userAccessCache[initialType]) {
      setUserRelationData(userAccessCache[initialType]);
    } else {
      userAccess({relation_type: initialType});
    }
    console.log(initialTabKey, 'initialTabKey', initialIndex, 'initialIndex');
  }, []);

  const {mutate: requestAccess, isLoading: isRequestAccessLoading} =
    useRequestUserRelations(
      data => {
        console.log('Request success:', data);
        setOpenRequestAccess(false);
        setMobileNumber('');
        setSelectedCoachType(undefined);
        setFormError('');
      },
      error => {
        console.error('Request failed:', error);
        const apiErrorMessage =
          error?.response?.data?.message ||
          'Something went wrong. Please try again.';
        setFormError(apiErrorMessage);
      },
    );

  const tabRoutes = [
    {key: 'parent', title: 'Parent'},
    {key: 'coach', title: 'Coach'},
    {key: 'mentor', title: 'Mentor'},
    {key: 'profile', title: 'My Profile Access'},
  ];

  const initialIndex = tabRoutes.findIndex(tab => tab.key === initialTabKey);
  const [index, setIndex] = useState(initialIndex !== -1 ? initialIndex : 3);
  const [routes] = useState(tabRoutes);

  const handleRequestAccess = () => {
    setOpenRequestAccess(true);
  };

  const handleCloseAccessModal = () => {
    setOpenRequestAccess(false);
    setMobileNumber('');
    setSelectedCoachType(undefined);
    setFormError('');
  };

  const handleOuterTabChange = newIndex => {
    setIndex(newIndex);
    const newTabKey = routes?.[newIndex]?.key;

    if (newTabKey) {
      navigation.setParams({tabType: newTabKey});
      setTabType('students_list');

      const newRelationType = newTabKey === 'profile' ? 1 : 0;

      if (relationType !== newRelationType) {
        setRelationType(newRelationType);
        // If data already cached, use it directly
        if (userAccessCache[newRelationType]) {
          setUserRelationData(userAccessCache[newRelationType]);
        } else {
          // Else, call API and cache on success
          userAccess({relation_type: newRelationType});
        }
      }
    }
  };

  const handleInnerTabChange = tabIndex => {
    const tabsForCurrent = getTabs(routes[index].key);
    const newTab = tabsForCurrent?.[tabIndex];
    if (newTab?.key) {
      setTabType(newTab.key);
    }
  };

  const getTabs = useCallback(
    (relationKey: any, isProfileTab = false) => [
      {
        key: 'students_list',
        label: 'Student List',
        component: () => (
          <StudentListComponent
            relationKey={relationKey}
            userRelationData={
              relationKey === 'Profile'
                ? Object.values(userAccessCache[1] || {}).flat()
                : userRelationData?.[relationKey]
            }
            accessType={
              relationKey === 'Profile' ? userAccessCache[1] : userRelationData
            }
            handleRequestAccess={handleRequestAccess}
            setModifyMainMenu={setModifyMainMenu}
          />
        ),
      },
      {
        key: 'pending_request',
        label: 'Pending Request',
        component: () => (
          <PendingRequest
            userData={userData}
            relationKey={relationKey}
            handleRequestAccess={handleRequestAccess}
          />
        ),
      },
    ],
    [userRelationData, setModifyMainMenu],
  );

  const [tabs, setTabs] = useState(getTabs(userRelationData));

  const UserAccessTabView = ({relationKey}) => {
    const isProfileTab = relationKey === 'profile';
    const data = isProfileTab
      ? userRelationData
      : userRelationData?.[relationKey] || [];
    const tabsForRelation = getTabs(relationKey, isProfileTab);

    return (
      <View
        style={{
          height: '100%',
          backgroundColor: CCColors.White,
          paddingHorizontal: 32,
          justifyContent: 'center',
          paddingTop: 20,
          borderRadius: 8,
        }}>
        <CCTabs
          key={tabType + relationKey}
          tabIndex={tabsForRelation.findIndex(t => t.key === tabType)}
          tabItems={tabsForRelation.filter(t => !t?.isHidden)}
          handleTabChange={handleInnerTabChange}
        />
      </View>
    );
  };

  const renderScene = useMemo(
    () =>
      SceneMap({
        parent: () => <UserAccessTabView relationKey="Parent" />,
        mentor: () => <UserAccessTabView relationKey="Mentor" />,
        coach: () => <UserAccessTabView relationKey="Coach" />,
        profile: () => <UserAccessTabView relationKey="Profile" />,
      }),
    [userRelationData, tabs, tabType],
  );

  useEffect(() => {
    if (userRelationData) {
      setTabs(getTabs(userRelationData));
    }
  }, [userRelationData, getTabs]);

  return (
    <View
      style={{
        minHeight: '100vh',
        backgroundColor: CCColors?.Primary?.lightBrown,
        padding: isMobileOrTab ? 5 : 32,
        flex: 1,
      }}>
      <Box
        {...(!isMobileOrTab && {type: 'row-center-between'})}
        style={isMobileOrTab ? {flexDirection: 'column'} : {}}>
        <Box
          {...(!isMobileOrTab && {type: 'row-flex-start'})}
          style={
            isMobileOrTab
              ? {flexDirection: 'row', justifyContent: 'space-between'}
              : {}
          }>
          <CCText fontSize={FontSizes[24]} color={CCColors.Primary.Dark}>
            Student List
          </CCText>
          {isMobileOrTab && (
            <CCButton
              titleStyle={{color: CCColors.TextColor.Dark}}
              style={{backgroundColor: CCColors.Primary.Action}}
              onPress={handleRequestAccess}>
              Request Access
            </CCButton>
          )}
        </Box>
        {isMobileOrTab && <Spacer spacing={20} />}
        <Box
          type={isMobileOrTab ? 'row-center-between' : 'row-flex-start'}
          style={{
            position: 'absolute',
            justifyContent: 'flex-end',
            right: 0,
            marginTop: '9%',
            zIndex: 9999,
          }}>
          <CCTextInput
            icon={search}
            fontSize={FontSizes[14]}
            value={searchTerm}
            style={{
              width: isMobileOrTab ? '100%' : '50%',
              height: 40,
              backgroundColor: CCColors.White,
              overflow: 'hidden',
            }}
            // autoFocus={searchTerm.length}
            placeholder="Search a Student"
            onChangeText={text => {
              setSearchTerm(text);
            }}
            placeholderTextColor={CCColors.TextColor.Grey}
          />
          {!isMobileOrTab && (
            <>
              <Spacer spacing={vs(36)} horizontal />
              <CCButton
                titleStyle={{color: CCColors.TextColor.Dark}}
                style={{backgroundColor: CCColors.Primary.Action}}
                onPress={handleRequestAccess}>
                Request Access
              </CCButton>
            </>
          )}
        </Box>
      </Box>
      <Spacer spacing={vs(isMobileOrTab ? 20 : 36)} />
      {/* <CCLoader loading bgWhite isComponentLoader /> */}

      <Box style={{zIndex: -1, height: '80%'}}>
        <TabView
          lazy
          navigationState={{index, routes}}
          renderScene={renderScene}
          onIndexChange={handleOuterTabChange}
          renderTabBar={props => {
            const {navigationState} = props;
            const {index: activeIndex, routes} = navigationState;

            return (
              <TabBar
                {...props}
                indicatorStyle={{
                  width: '25%',
                  height: '100%',
                  backgroundColor: CCColors.Primary.Brown,
                  borderTopLeftRadius:
                    props.navigationState.index === 0 ? 8 : 0,
                  borderBottomLeftRadius:
                    props.navigationState.index === 0 ? 8 : 0,
                  borderTopRightRadius:
                    props.navigationState.index ===
                    props.navigationState.routes.length - 1
                      ? 8
                      : 0,
                  borderBottomRightRadius:
                    props.navigationState.index ===
                    props.navigationState.routes.length - 1
                      ? 8
                      : 0,
                }}
                style={{
                  backgroundColor: CCColors?.White,
                  width: '48%',
                  borderWidth: StyleSheet.hairlineWidth,
                  borderColor: CCColors.Grey.Border,
                  padding: 0,
                  borderRadius: 8,
                  marginBottom: 40,
                }}
                contentContainerStyle={{
                  height: 32,
                }}
                renderLabel={({route, focused}) => {
                  const totalItems = routes.length;
                  const itemId = routes.findIndex(r => r.key === route.key);
                  return (
                    <CCText
                      fontSize={FontSizes[14]}
                      fontWeight="500"
                      style={[
                        styles.boxTabBarLabel,
                        focused ? styles.boxIndicator : {},
                        {
                          color: focused
                            ? CCColors.White
                            : CCColors.TextColor.Primary,
                        },
                        itemId === 0
                          ? styles.boxLeftBorder
                          : itemId === totalItems - 1
                          ? styles.boxRightBorder
                          : null,
                      ]}>
                      {route.title}
                    </CCText>
                  );
                }}
                tabStyle={{
                  flex: 1,
                  height: '100%',
                  paddingVertical: 45,
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRightWidth: 2,
                  borderRightColor: CCColors.BorderLight,
                }}
              />
            );
          }}
        />
      </Box>

      <SlideModal
        visible={openRequestAccess}
        onClose={handleCloseAccessModal}
        type="center"
        modalHeaderTitle="Request Access"
        customHeaderStyle={{
          fontSize: FontSizes[20],
          lineHeight: 30,
          fontWeight: 500,
          paddingVertical: 25,
          borderBottomWidth: 1,
          borderColor: CCColors?.BorderBottom,
        }}
        customStyle={{minWidth: 480, height: 396}}>
        <CCText
          fontSize={FontSizes[12]}
          style={{lineHeight: 18, fontWeight: 500}}>
          Add Student Mobile Number
        </CCText>
        <Spacer spacing={5} />
        <CCTextInput
          placeholder="Enter Mobile Number"
          value={mobileNumber}
          onChangeText={text => setMobileNumber(text)}
          style={{
            fontSize: 14,
            width: '100%',
            height: 40,
            backgroundColor: CCColors.White,
            overflow: 'hidden',
          }}
          placeholderTextColor={CCColors.TextColor.Grey}
          keyboardType="numeric"
        />
        <Spacer spacing={20} />
        <CCText
          fontSize={FontSizes[12]}
          style={{lineHeight: 18, fontWeight: 500}}>
          Need Access of
        </CCText>
        <Spacer spacing={5} />
        <View style={{flexDirection: 'row', gap: 8}}>
          {[
            {icon: 'school-outline', label: 'Coach'},
            {icon: 'book-open-page-variant-outline', label: 'Mentor'},
            {icon: 'account-outline', label: 'Parent'},
          ].map((item, index) => (
            <TouchableOpacity
              key={index}
              onPress={() => setSelectedCoachType(item.label)}
              style={{
                borderWidth: 1,
                borderColor: CCColors?.Box?.MiddleLine,
                paddingHorizontal: 16,
                paddingVertical: 10,
                flexDirection: 'row',
                alignItems: 'center',
                gap: 6,
                borderRadius: 12,
                alignSelf: 'flex-start',
                backgroundColor:
                  selectedCoachType === item.label ? '#FFF0C8' : 'transparent',
              }}>
              <MaterialCommunityIcons
                name={item.icon}
                size={20}
                color={CCColors.TextColor.LightGrey}
              />
              <CCText
                fontSize={FontSizes[14]}
                style={{lineHeight: 24, fontWeight: '500'}}
                color={CCColors.TextColor.LightGrey}>
                {item.label}
              </CCText>
            </TouchableOpacity>
          ))}
        </View>
        <Spacer spacing={30} />
        {formError ? (
          <>
            <CCText fontSize={FontSizes[12]} style={{color: CCColors?.Error}}>
              {formError}
            </CCText>
            <Spacer spacing={5} />
          </>
        ) : (
          <></>
        )}
        <CCButton
          onPress={() => {
            if (mobileNumber && selectedCoachType) {
              requestAccess(
                {
                  mobile_number: mobileNumber,
                  access_type: selectedCoachType,
                },
                {
                  onError: () => {
                    formError;
                  },
                },
              );
            }
          }}
          disabled={!mobileNumber || !selectedCoachType}>
          <CCText fontSize={FontSizes[16]}>Send Request</CCText>
        </CCButton>
      </SlideModal>
    </View>
  );
};

const styles = StyleSheet.create({
  boxLeftBorder: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  boxRightBorder: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  boxIndicator: {
    height: '0%',
    marginBottom: 20,
  },
  boxTabBarLabel: {
    color: CCColors?.White,
    paddingBottom: 55,
    lineHeight: 20,
  },
});

export default RequestAccess;
